const safeHtmlFilter = (value) => {
  if (!value) {
    return ''
  }
  if (typeof value !== 'string') {
    try {
      value = JSON.stringify(value)
    } catch (e) {
      value = ''
    }
  }
  const unsafeTags = ['html', 'head', 'body', 'style', 'script', 'iframe', 'embed', 'var', 'code', 'base', 'source']
  unsafeTags.forEach((tag) => {
    if (value.indexOf('<' + tag) > -1) {
      const regexp = new RegExp('<' + tag + '.*?>' + '.*?<\\/' + tag + '>', 'g')
      value = value.replace(regexp, '')
    }
  })
  value = value.replace(/<!--.+?-->/g, '')
  value = value.replace(/<(\w+)\s.+?>/g, '<$1>')
  return value
}

const SafeHtmlDirective = {
  beforeMount(el, binding) {
    el.innerHTML = safeHtmlFilter(binding.value)
  },
  updated(el, binding) {
    el.innerHTML = safeHtmlFilter(binding.value)
  },
}

const VueSafeHtml = {
  install(app) {
    app.directive('safe-html', SafeHtmlDirective)

    app.config.globalProperties.$safeHtml = safeHtmlFilter
  },
}

export { safeHtmlFilter, SafeHtmlDirective }
export default VueSafeHtml
